"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GambleEvents = void 0;
class GambleEvents {
}
exports.GambleEvents = GambleEvents;
GambleEvents.GAMBLE_STARTED = "NoLimitGamblePlugin_GambleStarted"; // this is fired when gamble is started.
GambleEvents.GAMBLE_PLAY_EFFECT_SOUND = "NoLimitGamblePlugin_PlayEffectSound"; // this is fired to play effect sound.
GambleEvents.GAMBLE_STOP_EFFECT_SOUND = "NoLimitGamblePlugin_StopEffectSound"; // this is fired to stop effect sound.
GambleEvents.GAMBLE_PLAY_KEYPAD_SOUND = "NoLimitGamblePlugin_PlayKeypadSound"; // this is fired to play keypad sound.
GambleEvents.GAMBLE_FINISHED = "NoLimitGamblePlugin_GambleFinished"; // this is fired when everything is finished.
//# sourceMappingURL=GambleEvents.js.map